export const ALLOWED_CONTENT_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf']
export const MAX_FILE_SIZE = 5 * 1024 * 1024
export const OPENING_TIMES = {
  weekdays: {
    start: '08:00',
    end: '20:00'
  },
  weekends: {
    start: '09:00',
    end: '16:00'
  }
}
export const VALIDATION = {
  CONTRACT_NUMBER: {
    REGEX: /^(\d{6}(.|-)?(\d{2}|\d{4}))$/, // NOTE: examples: 111111.11, 111111-11, 111111.11111, 111111-11111
    MIN_LENGTH: 8,
    MAX_LENGTH: 11
  },
  IBAN_REGEX: /^CH\d{2}\s*\d{5}\s*[A-Z0-9]{12}$/
}
